// Platform utilities for web
export const isDesktop = typeof window !== 'undefined' && window.navigator?.platform?.toLowerCase().includes('mac') || 
  window.navigator?.platform?.toLowerCase().includes('win') || 
  window.navigator?.platform?.toLowerCase().includes('linux');

export const isWeb = true;
export const isMobile = false;
